import Loader from "react-spinners/BeatLoader";
import { PRIMARY_COLOR } from "common/constants";

const LoadingIndicator = ({
  size = 35,
  color = PRIMARY_COLOR,
  loading = true,
  centered = true,
  className = ""
}) => {
  const spinner = (
    <Loader
      size={size}
      color={color}
      loading={loading}
      aria-label="Loading Spinner"
      data-testid="spinner"
    />
  );

  return centered ? (
    <div className={`d-flex justify-content-center align-items-center ${className}`} style={{ height: "100%" }}>
      {spinner}
    </div>
  ) : (
    <div className={className}>
      {spinner}
    </div>
  );
};

export default LoadingIndicator;
